
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faq3zZ7I1GyRcNKzEUw4MPqJ7DS6jW8GZ4gvKopTufQI5YMeta } from "/codebuild/output/src3248899494/src/src/pages/faq.vue?macro=true";
import { default as menuPt_45yx1H0UJC2flwTI1_45Nn7DYvcxKfN_ANdwANhmO9GgMeta } from "/codebuild/output/src3248899494/src/src/pages/menu.vue?macro=true";
import { default as indexuuK_zi5Irfi1GisOGPtthauvzwgiuPsrEiGBGmF36ZEMeta } from "/codebuild/output/src3248899494/src/src/pages/index.vue?macro=true";
import { default as contactjlBKGWNwxhwex250qNPzsnu_45i8c0yr_45EC7Pyj86Q2V4Meta } from "/codebuild/output/src3248899494/src/src/pages/contact.vue?macro=true";
import { default as tutorialRk53n2sGmpXmTzjfvMkk2R_45wTrBR26AEDaN8Z6fkhLUMeta } from "/codebuild/output/src3248899494/src/src/pages/tutorial.vue?macro=true";
import { default as agreementLuWLGwY1LvZMrKjb5rx1tOcg0dOMVnpjtW68RrdtdlcMeta } from "/codebuild/output/src3248899494/src/src/pages/agreement.vue?macro=true";
import { default as about_45passbwCE1of7yOEhgWkupGbrqohk4bS2ohRac3upLDRqSigMeta } from "/codebuild/output/src3248899494/src/src/pages/about-pass.vue?macro=true";
import { default as indexjj4MPYDHRks_KrVMWwbq6IxupS3ZR9DxtiRrDC3H_45yoMeta } from "/codebuild/output/src3248899494/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93Mc0q_HY8qxUzUKpcVsl0ppMfFarD0XMx8jTCoJl3IHwMeta } from "/codebuild/output/src3248899494/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceC6hCs81BrCEz24f33h4Q8JKTc0O1GUnVK7R5xjZJxnMMeta } from "/codebuild/output/src3248899494/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93iTlOhe1okuG1nT_lnWqr2bYYwakVRnQUmRuKlWYs_45QgMeta } from "/codebuild/output/src3248899494/src/src/pages/notice/[id].vue?macro=true";
import { default as indexfsWSdImSJkLUvl5PffObH29IIHSktS26KnA2_3GxnisMeta } from "/codebuild/output/src3248899494/src/src/pages/coupon/index.vue?macro=true";
import { default as indexCNwjDtc4LDCBH1AOJ5ar12Nrk7mPSn20fAlZiyLV4fYMeta } from "/codebuild/output/src3248899494/src/src/pages/mypage/index.vue?macro=true";
import { default as indexiqGQRAAgArv44SNWJwvnLWz4FJDfMSOTKnBCbRum6OYMeta } from "/codebuild/output/src3248899494/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_937zMjx14j5t_45O2PveDiMuhdgs9v_45H_45gGKtJYfePG6dR0Meta } from "/codebuild/output/src3248899494/src/src/pages/parking/[id].vue?macro=true";
import { default as indexHiI8uR36IINO1pwka7zvnYl_45YDAE8tufH6wLnprzXxkMeta } from "/codebuild/output/src3248899494/src/src/pages/history/index.vue?macro=true";
import { default as index4jpUpjbicmvXYBB_454jX7G1RnFwmwhfP3GEHU1cFphh4Meta } from "/codebuild/output/src3248899494/src/src/pages/monthly/index.vue?macro=true";
import { default as indextiJEYLsF2kKr_45OalnhH1YqvxU2VJk8Joj3eh3qNlGxMMeta } from "/codebuild/output/src3248899494/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexE41XalAvMKnnUOC5DcpIWVzRHV6N6Y1vWtlsR_dj9SUMeta } from "/codebuild/output/src3248899494/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviFu7kow1xZQs39eHpp9OFxRrOt3eCdyKeZCKMsfFaBoAMeta } from "/codebuild/output/src3248899494/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editW_45Hqq5vm405h00xQT7GFuLk4c4vv_em_45YuIBB2kDkSsMeta } from "/codebuild/output/src3248899494/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementFYafd_45aofbyCsAcuDDHu3ALC_hspviDv_4557sgIBD24YMeta } from "/codebuild/output/src3248899494/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexZlsCgDcdLtS6tnsVkrKbb2vXaQpRb7uqxkZohdM3ugYMeta } from "/codebuild/output/src3248899494/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dl6o3S80Dn4PZzj7JpdULrRTlNXs_453StcgUlgsfD_45g2YMeta } from "/codebuild/output/src3248899494/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmu_45uQYtBMpyxVD0r9Bm6pGx2158Se9hh4Vqu_Z3FA2tcMeta } from "/codebuild/output/src3248899494/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as index_x6mIFdm9SUqP6v_453A7BYy7oFVej546Z6wmhVGOavqoMeta } from "/codebuild/output/src3248899494/src/src/pages/card/create/index.vue?macro=true";
import { default as indexTXCd3me0sCHFEYBRkdw5UP2t_MFYRXxqRKexL6xzGV4Meta } from "/codebuild/output/src3248899494/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirm_yI3w_l01jm7TZhPzGH2cqAT6E14caOVDyeDwXvZS_45YMeta } from "/codebuild/output/src3248899494/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmuLjQL_QkryuF5re1jXxpiAI8IG1S7C52SvMIRa5AcE8Meta } from "/codebuild/output/src3248899494/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeN2lvtR4u1_HP3DmWjsXOx6tLWMCsQPaxphGYLathmmEMeta } from "/codebuild/output/src3248899494/src/src/pages/membership/complete.vue?macro=true";
import { default as registerUtXt_45uiTB1c8xofCBcvfsnAHNhUZaOBSRcUZLS4dHbQMeta } from "/codebuild/output/src3248899494/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93BjLqgWZgQw_45eB5ZkRVGdMAkAjUhaPE67Ctm8U1aUH58Meta } from "/codebuild/output/src3248899494/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirm7z1Pzs5DQOk4gnQPXYCPxSSIfHUbOj5_45prfX524RFIgMeta } from "/codebuild/output/src3248899494/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93Ujhcm1VJwTEq8jWpr9E3vQQT0HfiOz8QDlUjLhYTtH0Meta } from "/codebuild/output/src3248899494/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexWAgda8_HToOG_45SyHRen8QWs09W3tpN2Y3adrdH08ZhoMeta } from "/codebuild/output/src3248899494/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeOy4ymldURwzKdqqB74920giAxmDNIEQxd7xFqUsNwUgMeta } from "/codebuild/output/src3248899494/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeBOaDPLQ8ys8s7Sl_lCzs8vNtMSI40E2y4rMZmKPnth0Meta } from "/codebuild/output/src3248899494/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completegCZm1Uua02oV0DK4ONVh2zOsxAW2UsbyIKVcI2H9QwoMeta } from "/codebuild/output/src3248899494/src/src/pages/contact-form/complete.vue?macro=true";
import { default as register_rDoOtMpNaQcKjElPyKQYEvjWThVkbHNx6utFodMxs8Meta } from "/codebuild/output/src3248899494/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeDnlAgvqkhlM8ha3u_45YHdZN_45_45pIroFBdvgOSW7kwCjMYMeta } from "/codebuild/output/src3248899494/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexH3l_45k1TE2ZEQj_bzEdQNoGrU1kNXwykYhCizdLgNUVUMeta } from "/codebuild/output/src3248899494/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmnfRoZ5yfUbEvJDl880QncFF0B3twuSzgy5Is3G_45zTtEMeta } from "/codebuild/output/src3248899494/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completezOvReO7BbE3SS_451bceYtMiBxDVOKdxvoFX2lbuwsuaYMeta } from "/codebuild/output/src3248899494/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexwGtHy48MaefJbhbHP1fwc6_450YWpzjy0vFIyOUGnZ9EIMeta } from "/codebuild/output/src3248899494/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93INmahMVchSoIy_45QI1ZVWwS2QIOMWdSN_XzY_LSDaoy4Meta } from "/codebuild/output/src3248899494/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeEtrUtTHZP3bJXxI3W_b8C_kD1ocYa476JbmCDJJB3G8Meta } from "/codebuild/output/src3248899494/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliashOK5D2cjJkvdiykA_459FJ7qLua1paQCdb9FulwHMirwYMeta } from "/codebuild/output/src3248899494/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as samplej8t58AZ78we6jJ6WrB_yUiYXC1pFe7CiY_ZKXwffPnAMeta } from "/codebuild/output/src3248899494/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailprKdsIXcvCxN8k_bUab1ZoqtEhYykKyAV3KqOdtOv3wMeta } from "/codebuild/output/src3248899494/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmnGcFxnz1xabK_456flrWF1HMTkIdwgBf6bboymhsU_45l7AMeta } from "/codebuild/output/src3248899494/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentCDYKqTRU7nE_sw1LHGdYBoyHZK1_45C_fD4OgIhWEsaSUMeta } from "/codebuild/output/src3248899494/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmjn3_45gqUNhZvmGuj8M5u4PKOANLl6W_45xc_45mcWtx_QsUwMeta } from "/codebuild/output/src3248899494/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedatejlHZRKcnt3yxKu5sV1kLkGpd5B9i3BOJ1cTbATs587oMeta } from "/codebuild/output/src3248899494/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeMcRjDxCv7Gux5PDrHvcjuJJoERBONDd9BoX2FRKAP30Meta } from "/codebuild/output/src3248899494/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeSlu1DC9obVGKqlBzDWsPBmG_45yEwpv0P7r_EFVoNdtQgMeta } from "/codebuild/output/src3248899494/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45password6mezzJl8FEAX3U1gl7CJl6sGVQI_45arD9dPgF9telPgcMeta } from "/codebuild/output/src3248899494/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasCVUO7OPMQw_457OA9RHmmbU00ORQDekf8cELHxOCWhO14Meta } from "/codebuild/output/src3248899494/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerPrSd9XEKG0E93yqIIPEm6RUSe_vjLIXcCCBBKmyo6UEMeta } from "/codebuild/output/src3248899494/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45code3PNljeFZaThq4Jjw4Z2Po9I4OJESL9k3PY5mFaKLLjMMeta } from "/codebuild/output/src3248899494/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexR0ocWp5dXFLbe5yMHrZkTci6EgFxbcj1ggHaMxrm0ekMeta } from "/codebuild/output/src3248899494/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexRyBpo027K2Dg1J_MXrAYeDUiKAhKmATNllbd76tjsM4Meta } from "/codebuild/output/src3248899494/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexq278GtqfHWkTW5ihjQ_45n57_45WSCqgJlJhhN5zWK2By8cMeta } from "/codebuild/output/src3248899494/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexXnbTuofrEM1ZYT9g25jtMTrBgtWYSmiP_AaJlC0lQt8Meta } from "/codebuild/output/src3248899494/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateBRLSELOj4CRTZjEwir9HWCi6FGdZtKHTrpnioYuiFTYMeta } from "/codebuild/output/src3248899494/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeiAOeY_45Jh7ZdriERQOkyczrekyR9pZKwlS0VnjtzcxUQMeta } from "/codebuild/output/src3248899494/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmEjJ2z5dCv1KiEW4X4yvENQ6cb1_45ZRx3AgxrCMSkCX9AMeta } from "/codebuild/output/src3248899494/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as index3DJbypnqIrcwiB6InjOWExC1YAaBdPtHtrS09lSJRFoMeta } from "/codebuild/output/src3248899494/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as complete1wUz0pniyM_45S3sbH0fEXUmkiCGw_45dUldGKPGIp5auRQMeta } from "/codebuild/output/src3248899494/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updater0F_45_7yvLwmRWVroBMak4EsTb4_45fruYrBOYvOieE7qwMeta } from "/codebuild/output/src3248899494/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexUSgY6r_45uBtIN_45AbvrziaX9Fh_JTQ4dUX2ovmpaSCnhsMeta } from "/codebuild/output/src3248899494/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexc_453Mi_45lRrYOMjfUrC3j7jhNJq3Y1YuEF7WistboCq1sMeta } from "/codebuild/output/src3248899494/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completePu0dtcPJw_2sUjmdhUzITXU2H_M969SGAg76Hhu2OdUMeta } from "/codebuild/output/src3248899494/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexfD4UCBYSCXTvIiSSiwoT170aEZTnhlnwYpAauJCay5AMeta } from "/codebuild/output/src3248899494/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codesGEE0EO4fqYgodfgRYhcEsYvy6apeapkOx8wd4pLkEwMeta } from "/codebuild/output/src3248899494/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexBNINmhcSGozKTgbLpsN5kblu6y0n9O_45gH7dDq_45Uexb8Meta } from "/codebuild/output/src3248899494/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexvxNao7fOrKKHDxIOGnx2P8TD0JaDD3Hw_452mXDp_45wEB8Meta } from "/codebuild/output/src3248899494/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexZxL00G7JQd0Pe25WkTk7VBSu1yPseVk2vEjMlYwW9pUMeta } from "/codebuild/output/src3248899494/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as update3oxfoIv6mcFq7_45TPpmDXOlAyRR6VMngoOshf0m5ZyFoMeta } from "/codebuild/output/src3248899494/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirm3BQ1NuJmFMERFE_nSiUBcIJ6jcguhmY_45dic8eHHZRTkMeta } from "/codebuild/output/src3248899494/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src3248899494/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuPt_45yx1H0UJC2flwTI1_45Nn7DYvcxKfN_ANdwANhmO9GgMeta || {},
    component: () => import("/codebuild/output/src3248899494/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexuuK_zi5Irfi1GisOGPtthauvzwgiuPsrEiGBGmF36ZEMeta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src3248899494/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src3248899494/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src3248899494/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src3248899494/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src3248899494/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src3248899494/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src3248899494/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src3248899494/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src3248899494/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexfsWSdImSJkLUvl5PffObH29IIHSktS26KnA2_3GxnisMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src3248899494/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src3248899494/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src3248899494/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src3248899494/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexHiI8uR36IINO1pwka7zvnYl_45YDAE8tufH6wLnprzXxkMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src3248899494/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src3248899494/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indextiJEYLsF2kKr_45OalnhH1YqvxU2VJk8Joj3eh3qNlGxMMeta || {},
    component: () => import("/codebuild/output/src3248899494/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexE41XalAvMKnnUOC5DcpIWVzRHV6N6Y1vWtlsR_dj9SUMeta || {},
    component: () => import("/codebuild/output/src3248899494/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src3248899494/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3248899494/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src3248899494/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src3248899494/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src3248899494/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3248899494/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: index_x6mIFdm9SUqP6v_453A7BYy7oFVej546Z6wmhVGOavqoMeta || {},
    component: () => import("/codebuild/output/src3248899494/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src3248899494/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirm_yI3w_l01jm7TZhPzGH2cqAT6E14caOVDyeDwXvZS_45YMeta || {},
    component: () => import("/codebuild/output/src3248899494/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmuLjQL_QkryuF5re1jXxpiAI8IG1S7C52SvMIRa5AcE8Meta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src3248899494/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeN2lvtR4u1_HP3DmWjsXOx6tLWMCsQPaxphGYLathmmEMeta || {},
    component: () => import("/codebuild/output/src3248899494/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerUtXt_45uiTB1c8xofCBcvfsnAHNhUZaOBSRcUZLS4dHbQMeta || {},
    component: () => import("/codebuild/output/src3248899494/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src3248899494/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirm7z1Pzs5DQOk4gnQPXYCPxSSIfHUbOj5_45prfX524RFIgMeta || {},
    component: () => import("/codebuild/output/src3248899494/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src3248899494/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src3248899494/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeOy4ymldURwzKdqqB74920giAxmDNIEQxd7xFqUsNwUgMeta || {},
    component: () => import("/codebuild/output/src3248899494/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeBOaDPLQ8ys8s7Sl_lCzs8vNtMSI40E2y4rMZmKPnth0Meta || {},
    component: () => import("/codebuild/output/src3248899494/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completegCZm1Uua02oV0DK4ONVh2zOsxAW2UsbyIKVcI2H9QwoMeta || {},
    component: () => import("/codebuild/output/src3248899494/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: register_rDoOtMpNaQcKjElPyKQYEvjWThVkbHNx6utFodMxs8Meta || {},
    component: () => import("/codebuild/output/src3248899494/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src3248899494/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src3248899494/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmnfRoZ5yfUbEvJDl880QncFF0B3twuSzgy5Is3G_45zTtEMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src3248899494/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completezOvReO7BbE3SS_451bceYtMiBxDVOKdxvoFX2lbuwsuaYMeta || {},
    component: () => import("/codebuild/output/src3248899494/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexwGtHy48MaefJbhbHP1fwc6_450YWpzjy0vFIyOUGnZ9EIMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3248899494/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src3248899494/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeEtrUtTHZP3bJXxI3W_b8C_kD1ocYa476JbmCDJJB3G8Meta || {},
    component: () => import("/codebuild/output/src3248899494/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3248899494/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(samplej8t58AZ78we6jJ6WrB_yUiYXC1pFe7CiY_ZKXwffPnAMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3248899494/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailprKdsIXcvCxN8k_bUab1ZoqtEhYykKyAV3KqOdtOv3wMeta || {},
    component: () => import("/codebuild/output/src3248899494/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmnGcFxnz1xabK_456flrWF1HMTkIdwgBf6bboymhsU_45l7AMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3248899494/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentCDYKqTRU7nE_sw1LHGdYBoyHZK1_45C_fD4OgIhWEsaSUMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3248899494/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmjn3_45gqUNhZvmGuj8M5u4PKOANLl6W_45xc_45mcWtx_QsUwMeta || {},
    component: () => import("/codebuild/output/src3248899494/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src3248899494/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeMcRjDxCv7Gux5PDrHvcjuJJoERBONDd9BoX2FRKAP30Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3248899494/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeSlu1DC9obVGKqlBzDWsPBmG_45yEwpv0P7r_EFVoNdtQgMeta || {},
    component: () => import("/codebuild/output/src3248899494/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45password6mezzJl8FEAX3U1gl7CJl6sGVQI_45arD9dPgF9telPgcMeta || {},
    component: () => import("/codebuild/output/src3248899494/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3248899494/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerPrSd9XEKG0E93yqIIPEm6RUSe_vjLIXcCCBBKmyo6UEMeta || {},
    component: () => import("/codebuild/output/src3248899494/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45code3PNljeFZaThq4Jjw4Z2Po9I4OJESL9k3PY5mFaKLLjMMeta || {},
    component: () => import("/codebuild/output/src3248899494/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src3248899494/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src3248899494/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src3248899494/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src3248899494/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src3248899494/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src3248899494/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src3248899494/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src3248899494/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src3248899494/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src3248899494/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src3248899494/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src3248899494/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src3248899494/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src3248899494/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src3248899494/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src3248899494/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src3248899494/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src3248899494/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src3248899494/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src3248899494/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]